const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

const requestDetailsSuccess = (response, accountId, transferId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_DETAILS_SUCCESS,
    payload: {
        transferId: transferId,
        accountId: accountId,
        details: response
    }
});

const requestDetailsFailure = (error, accountId, transferId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_DETAILS_FAILURE,
    payload: {
        transferId: transferId,
        error: error,
        accountId: accountId
    }
});

const requestDetailsRequest = (accountId, transferId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_DETAILS_REQUEST,
    payload: {
        transferId: transferId,
        accountId: accountId
    }
});

const getScheduledTransfersDetails = (accountId, scheduledTransfersId, callback, url) => (dispatch, getState) => {
    const TRANSFERENCIAS_DIFERIDAS = 'D';
    const TRANSFERENCIAS_PERIODICAS = 'P';

    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immScheduledTransaction = getState().scheduledTransfers.getIn([
        accountId,
        'byId',
        scheduledTransfersId
    ]);

    let tipoTransferencia =
        immScheduledTransaction.get('transferType') === 'TRANSFERENCIAS PERIODICAS'
            ? TRANSFERENCIAS_PERIODICAS
            : TRANSFERENCIAS_DIFERIDAS;
    const detailsRequestData = {
        query: {
            tipoTransferencia,
            contratoOrdenanteProducto: immAccount.get('newProduct'),
            contratoOrdenanteNumeroContrato: immAccount.get('newContractNumber'),
            numeroOrdenCabecera: immScheduledTransaction.getIn(['extra', 'numOrdCabMisPag'])
        }
    };

    if (tipoTransferencia === TRANSFERENCIAS_PERIODICAS) {
        detailsRequestData.query.tipoSeleccion = 'S'; // SEPA
    } else {
        // TODO: check fields from previous request to decide if it's sespa or not, based on naturalezapagomispag
        // We are leaving it fixed for now.
        detailsRequestData.query.tipoSeleccion = 'S';
    }

    dispatch(requestDetailsRequest(accountId, scheduledTransfersId));
    return APIGet(dispatch, apiURLBuilder.getURL('scheduledTransfersDetails'), detailsRequestData)
        .then(response =>
            {
                dispatch(requestDetailsSuccess(response, accountId, scheduledTransfersId));
                if (callback) { callback(url) }
            }
        )
        .catch(error => dispatch(requestDetailsFailure(error, accountId, scheduledTransfersId)))
};

module.exports = {
    getScheduledTransfersDetails
};
